module.exports = __webpack_public_path__ + "static/legacy_bn2@2x-c274cc66732a1c3cbca300ac67f31e1e.jpg";